import { UI, VStack } from '@genial/components';
import React, { useEffect } from 'react';

import { UserSelectionsProps } from '../..';
import { InputMoney } from '../../../../../../../../../../../../components/InputMoney';
import { InputPercentage } from '../../../../../../../../../../../../components/InputPercentage';
import { usePublicOfferAssetFixedController } from '../../../../../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/PublicOffer';

export interface PublicOfferFixedFieldsProps extends Required<UserSelectionsProps> {}

export const PublicOfferFixedFields: React.FC<PublicOfferFixedFieldsProps> = ({
  offer,
  offerDetails,
  selectedModality,
  setUserSelectionValues,
}) => {
  const id = offer.offerId;

  const {
    control,
    currentValue,
    currentValueFormatted,
    currentRemuneration,
    currentRemunerationFormatted,
    minimumValue,
    handleInputValueBlur,
    handleInputValueClear,
    handleInputValueFocus,
    handleSubmit,
    hasErrorValue,
    isValueFocused,
  } = usePublicOfferAssetFixedController(offer, offerDetails, selectedModality);

  useEffect(() => {
    setUserSelectionValues((prev) => ({
      ...prev,
      currentRemuneration,
      currentValue,
      hasError: !!hasErrorValue,
    }));
  }, [currentRemuneration, currentValue, id, hasErrorValue, setUserSelectionValues]);

  return (
    <VStack space="stack.xxxs">
      <VStack space="stack.quarck">
        <UI.Text color="neutral.black" variant="semibold">
          Valor desejado
        </UI.Text>

        <InputMoney
          id={`public-offer-value-input${id}`}
          name="priceItem"
          control={control}
          handleFocus={handleInputValueFocus}
          handleBlur={handleInputValueBlur}
          handleSubmit={handleSubmit}
          handleClear={handleInputValueClear}
          currentValue={currentValueFormatted}
          hasFocus={isValueFocused}
          minValue={minimumValue}
          customInputProps={{
            ...{ ...(isValueFocused && hasErrorValue && { error: hasErrorValue }) },
          }}
        />
      </VStack>
      <VStack space="stack.quarck">
        <UI.Text color="neutral.black" variant="semibold">
          Remuneração fixa
        </UI.Text>

        <InputPercentage
          isDisabled
          customPressableProps={{
            bg: 'neutral.lightest',
            color: 'neutral.light',
          }}
          id={`public-offer-remuneration-input${id}`}
          name="remuneration"
          control={control}
          handleFocus={() => {}}
          handleBlur={() => {}}
          handleSubmit={handleSubmit}
          handleClear={() => {}}
          currentValue={currentRemunerationFormatted}
          hasFocus={false}
          minValue={0}
        />
      </VStack>
    </VStack>
  );
};
